function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-edb4bdc4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=v6bwv9n4fgn!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=oue8yteht5p!./ResultList.vue")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=v6bwv9n4fgn!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=oue8yteht5p!./ResultList.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-edb4bdc4\",\"hasScoped\":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=v6bwv9n4fgn!../../../../node_modules/string-replace-webpack-plugin/loader.js?id=oue8yteht5p!./ResultList.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-edb4bdc4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ecommerce/filter/ResultList.vue
// module id = 606
// module chunks = 0